import { useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import GetUser from "../../services/get-user";
import { Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { FileUploader } from "react-drag-drop-files";
import { CircularProgress } from "@material-ui/core";
import { toast } from "react-toastify";
import Alert from "@mui/material/Alert";
import "../../styling/sidebar.css";
import CsvWithAdvanceOption from "./csvWithAdvanceOption";
import { Popover, Typography } from "@material-ui/core";

export default function REPopup(props) {
  const [excelData, setExcelData] = useState<any>([]);
  const [advanceDisableButton, setAdvanceDisableButton] = useState(true);
  const [importDisableButton, setImportDisableButton] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [loading, setLoading] = useState(false);
  const openTooltip = Boolean(anchorEl);
  const fileTypes = ["xlsx", "xls"];
  const user = GetUser();
  let fileData = [];

  const handleSubmit = async (d: any) => {
    d.preventDefault();
    fileData = excelData.map((obj) => Object.values(obj));
    setLoading(true)
    try {
      return axios
        .post(
          "https://sotira-back-test.herokuapp.com/expense/add_csv_expense",
          {
            userID: user.userID,
            incomeStream: props.stream + 1,
            expenses: fileData,
          }
        )
        .then(() => {
          sessionStorage.setItem("option", "expense");
          toast.success("File Uploaded successfully.", {
            position: "top-right",
            autoClose: 15000,
          });
          setLoading(false);
          props.setOpenExcelModal(false);
          if(props.closeExpenseModal!==undefined){ 
            props.closeExpenseModal(false)
          };
          props.setReloadAPI((prevState)=>!prevState);
        });
    } catch (e: any) {
      setLoading(false);
      alert(e.response.data);
    }
  };

  const getExcelFileData = (file) => {
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = (e: any) => {
      const bufferArray = e.target?.result;
      let workBook = XLSX.read(bufferArray, {
        type: "buffer",
        dateNF: "YYYY-MM-DD",
        cellDates: true,
        cellNF: false,
        cellText: true,
      });
      const wsname = workBook.SheetNames[0];
      const workSheet = workBook.Sheets[wsname];
      const csvFileRecords: any = XLSX.utils.sheet_to_json(workSheet, { header: 1 });
      const headers: any = csvFileRecords[0].map((item: any) => {
        if (item !== "name" && item.toLowerCase().includes("name")) {
          item = "name";
        }
        return item.toLowerCase().trim();
      });
      if(headers.length >=2){
        if (headers.indexOf("name") === -1 || headers.indexOf("amount") === -1) {
          setImportDisableButton(true);
          setAdvanceDisableButton(false);
          toast.error("Name or amount field is missing.", {
            position: "top-right",
            autoClose: 15000,
          });
        const fileRowsData = csvFileRecords.slice(1); 
          if (fileRowsData.length === 0) {
            setImportDisableButton(true);
            setAdvanceDisableButton(true);
            toast.error("After cleaning the data, no data could be sent.", {
              position: "top-right",
              autoClose: 15000,
            });
            return ["No good data was found"];
          } else {
            fileRowsData.unshift(headers);
            setImportDisableButton(true);
            setAdvanceDisableButton(false);
            setExcelData(fileRowsData);
            return fileRowsData;
          }
        } else {          
          const fileHeaders: any =  csvFileRecords.slice(1);
          const nameIndex = headers.indexOf("name");
          const amountIndex = headers.indexOf("amount");
          const dateIndex = headers.indexOf("date");
          
          var fileRowsData: any[] = [];
          for (var i in fileHeaders) {
            if (
              fileHeaders[i][nameIndex] &&
              fileHeaders[i][amountIndex] 
            ) {
              const typeAmount = typeof fileHeaders[i][amountIndex]
              fileHeaders[i][amountIndex] = fileHeaders[i][amountIndex] && 
                            (typeAmount === 'string' &&  fileHeaders[i][amountIndex].startsWith("$"))? fileHeaders[i][amountIndex].replaceAll(",","").split("$").join("").trim() : Number(fileHeaders[i][amountIndex]);
              if(isNaN(fileHeaders[i][amountIndex]) || !fileHeaders[i][amountIndex]){
                toast.error("amount should be number");
                break;
              }else{
                Number(fileHeaders[i][amountIndex])
              }

              if (dateIndex != -1) {
                var sendDate = new Date(fileHeaders[i][dateIndex]);
                var currDate = new Date();
                if (
                  isNaN(sendDate.getTime()) ||
                  sendDate.getTime() > currDate.getTime()
                ) {
                  sendDate = new Date();
                }
                fileHeaders[i][dateIndex] = sendDate;
              }
              fileRowsData.push(fileHeaders[i]);
            } else {
              setImportDisableButton(true);
              setAdvanceDisableButton(true);
              toast.error("Name or amount field is missing.", {
                position: "top-right",
                autoClose: 15000,
              });
              return ["No good data was found"];
            }
            setImportDisableButton(false);
            setAdvanceDisableButton(false);
          }
          if (fileRowsData.length === 0) {
            setImportDisableButton(true);
            setAdvanceDisableButton(true);
            toast.error("After cleaning the data, no data could be sent.", {
              position: "top-right",
              autoClose: 15000,
            });
            return ["No good data was found"];
          } else {
            fileRowsData.unshift(headers);
            setImportDisableButton(false);
            setAdvanceDisableButton(false);
            setExcelData(fileRowsData);
            return fileRowsData;
          }
        }
      }
      else{
        setImportDisableButton(true);
        setAdvanceDisableButton(true);
        toast.error("Name or amount Header is missing.", {
          position: "top-right",
          autoClose: 15000,
        });
      }
    };
  };

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {openModal && (
        <CsvWithAdvanceOption
          csvFileRecords={excelData.filter((data) => data.length >= 2)}
          stream={props.stream}
          openModal={openModal}
          setOpenModal={(isOpen) => {
            setOpenModal(isOpen)
            if (!isOpen && props.setOpenExcelModal) {
              props.setOpenExcelModal(false);
            }
          }}
          closeExpenseModal={props.closeExpenseModal}
          setReloadAPI={props.setReloadAPI}
        />
      )}
      <Form onSubmit={handleSubmit} className="csv-form">
        <Form.Group>
          <div className="excel-header">
            Example of an acceptable excel file:
            <a
              href="https://docs.google.com/spreadsheets/d/1JfhQpxs-tS6V-fWzJ6tkI_gfvD-3-Y3oV3OH1CdLHy4/edit?usp=sharing"
              target="_blank"
            >
              Example
            </a>
            ('Name' and 'Amount' columns are mandatory)
          </div>
        </Form.Group>
        <Form.Group>
          <FileUploader
            type="file"
            types={fileTypes}
            handleChange={(e: any) => {
              getExcelFileData(e);
            }}
            className="file-upload"
          />

          <Alert severity="error" className="mt-3">
            Trouble uploading your expenses? Email your file to{" "}
            <a href="mailto:support@sotira.co">support@sotira.co</a> or{" "}
            <a href="https://calendly.com/amritabhasin/15min?back=1&month=2022-08">
              schedule a meeting at this link
            </a>{" "}
            and we will upload it for you :)
          </Alert>

          <div className="d-flex justify-content-between align-items-center excel-dialog-wrapper" id="excel-dialog-wrapper">
          <Typography
            aria-owns={openTooltip ? "mouse-over-popover" : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            className="excel-advanced-button"
            id="excel-advanced-button"
          >
            <Button
              block
              size="sm"
              disabled={advanceDisableButton}
              onClick={() => {
                setOpenModal(true);
              }}
              className={
                advanceDisableButton
                  ? "mt-3 float-left disable-button"
                  : "mt-3 float-left"
              }
            >
              Advanced
            </Button>
          </Typography>
          <Popover
            id="mouse-over-popover"
            open={openTooltip}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            {advanceDisableButton && (
              <Typography className="questionmark-popover text-white p-1">
                Please upload a csv/excel sheet first!!!
              </Typography>
            )}
          </Popover>
          <Button
            className="excel-button mt-3 p-1"
            type="submit"
            disabled={importDisableButton}
            id="excel-button"
          >
          {loading ?
          <><CircularProgress className="file-loader mr-3" /> Uploading </>
          : 'Import Excel Sheet'
          }  
          </Button>
          </div>
        </Form.Group>
      </Form>
    </div>
  );
}
